import React, {useContext, useRef, useState} from "react";
import {APIProvider, Map, MapCameraChangedEvent, Marker} from '@vis.gl/react-google-maps';
import {StoreLocatorContext} from "../context/store-locator";
import {DealerSearchData} from "../lib/dealer-service";



const DealerMap = () => {
    const context = useContext(StoreLocatorContext)

    if (context.position == null)
        return (
            <div className={'dealer-map'}>
                <div className="lmp_products_loading">
                    <i className="fa fa-spinner lmp_rotate"></i>
                    <span className=""></span>
                </div>
            </div>
        );
    let markers:React.JSX.Element[] = [];
    if(context.dealers && context.dealers.length>0){
        markers=context.dealers.map((d:DealerSearchData)=>{
            return (
                <Marker
                    key={d.id}
                    position={{lat:parseFloat(d.lat),lng:parseFloat(d.lng)}}
                    title={d.detail.company}
                    icon={{
                        url:(window as any).rz_store_locator.marker_icon_url,
                        scaledSize:new google.maps.Size(40, 40)
                    }}
                    onClick={()=>context.selectDealer(d)}

                    />
            )
        })
    }


    return (
        <div className={'dealer-map'}>
            <Map

                scrollwheel={true}
                fullscreenControl={false}
                streetViewControl={false}
                zoomControl={true}
                mapTypeControl={false}
                zoomControlOptions={{
                    position: 20,
                }}
                zoom={context.zoom}
                center={context.position}
                styles={[
                    {
                        featureType: 'all',
                        elementType: 'all',
                        stylers: [
                            {
                                saturation: -100,
                            },
                            {
                                gamma: 2.0,
                            },
                        ],
                    },
                    {
                        featureType: 'poi',
                        stylers: [{visibility: 'off'}],
                    },
                ]}
                onCameraChanged={(ev: MapCameraChangedEvent) => {
                    const center = ev.detail.center;
                    if(center.lat!=context.position?.lat || center.lng!=context.position.lng) {
                        context.setPosition(ev.detail.center);
                    }
                    if(ev.detail.zoom!=context.zoom) {
                        context.setZoom(ev.detail.zoom);
                    }
                }
                }>
                {markers}
            </Map>
        </div>
    )
}

export default DealerMap;
